import type { CSSProperties } from '@vue/runtime-dom'

export type Fn = (...args: any) => any

export type CSSStyle = CSSProperties
export type CSSClassList = string[]

export interface SettingsBarProperty {
  opacity: number
  height: number
}

export interface SwitchingSettingsPeriodInitialProperty {
  // opacity: number
  width: number
  color: string
}

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export type Sorting = {
  direction: SortDirection
  order: number // actually just use timestamp when added
}

export type HasSorting = { sorting: Sorting }

export type WithSorting<T> = Omit<T, 'sorting'> & {
  sorting: Sorting
}

export function hasSorting(item: object): item is HasSorting {
  return 'sorting' in item && item.sorting !== null
}
